import { defineStore } from 'pinia'

//グローバル変数用ストア
export const useStoreBreadcrumbInfo = defineStore('breadcrumbInfo', {
  state: () => ({
    breadcrumbList: []
  }),
})